import { useState, useEffect } from "react";

export default function useImage(url) {
  const [img, setImg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!url) {
      setImg(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const image = new window.Image();
    // إذا كان الرابط خارجي فقط نستخدم crossOrigin
    if (!url.startsWith("/uploads") && !url.startsWith("uploads")) {
      image.crossOrigin = "anonymous";
    }
    
    // تحسين دعم GIF
    const isGif = url.toLowerCase().endsWith('.gif');
    
    image.onload = () => {
      setImg(image);
      setLoading(false);
      
      // تحسين إضافي لملفات GIF
      if (isGif) {
        // إعادة تحميل GIF لضمان الحركة
        setTimeout(() => {
          if (image.src === url) {
            image.src = url + '?t=' + Date.now();
          }
        }, 100);
      }
    };
    
    image.onerror = () => {
      setError(isGif ? 'فشل في تحميل ملف GIF' : 'فشل في تحميل الصورة');
      setLoading(false);
    };

    image.src = url;

    return () => {
      setImg(null);
      setLoading(false);
      setError(null);
    };
  }, [url]);

  return [img, loading, error];
}
